import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap5';

import { useTableContext } from '../TableContext';
import Actions from '../Actions';

export default function TextFilter({ name }) {
  const { state, dispatch } = useTableContext();
  const filterValue = state.selectedFilters[name] || '';

  return (
    <Form.Control
      placeholder={`Search by ${name}`}
      value={filterValue}
      onChange={(e) => Actions.searchByText(dispatch, name, e.target.value)}
    />
  );
}

TextFilter.propTypes = {
  name: PropTypes.string.isRequired,
};
